export const Events = {
  USER_ERROR: "Received user error",
  SERVER_ERROR: "Received server error",
  VIEWED_ESTIMATE: "Viewed estimate form",
  VIEWED_APP_FORM: "Viewed loan app form",
  COMPLETED_ESTIMATE: "Submitted estimate",
  VIEWED_ESTIMATE_RESULT: "Viewed estimate result",
  CLICKED_ESTIMATE_OFFER: "Clicked estimate offer",
  VIEWED_APPLICATION_FORM: "Viewed loan application form",
  CONTINUE_TO_BANK_STATEMENTS: "Continued to bank statements",
  VIEWED_BANK_STATEMENTS: "Viewed loan application bank statements page",
  CONTINUE_TO_CONFIRMATION: "Continued to confirmation",
  VIEWED_APPLICATION_FORM_CONFIRMATION:
    "Viewed loan application confirmation page",
  SUBMIT_APPLICATION: "Submitted loan application",
  VIEWED_PRESUBMIT_NSR: "Viewed pre-submit NSR fail",
  CLICKED_FORM_FIELD: "Rate estimate field clicked",
  VIEWED_404: "Viewed quote 404 page",
  PRESENTED_DRIVA: "Presented Driva offer",
} as const;

export const LOAN_APPLICATION = "Wisr loan";
export const QUOTE_APPLICATION = "Wisr website";
export const UNEXPECTED_ERROR = "Unexpected Error";

export const LoanStatus = {
  QUOTE_STARTED: "Started estimate",
  QUOTE_SUBMITTED: "Submitted estimate",
  ESTIMATE_PRESENTED: "Presented estimate",
  APPLICATION_STARTED: "Started application",
  CONTINUED_TO_BANK_STATEMENTS: "Continued to bank statements",
  STARTED_BANK_STATEMENTS: "Viewed bank statements page",
  CONTINUED_TO_CONFIRMATION: "Continued to confirmation",
  STARTED_APP_CONFIRMATION: "Started application confirmation",
  SUBMIT_APPLICATION: "Submitted application",
  PRESUBMIT_NSR_FAIL: "Pre-submit NSR fail",
} as const;

export const HotjarAttributes = {
  VIEWED_ESTIMATE_RESULT: "Viewed estimate result",
} as const;

export const ViewedEstimateResult = {
  OFFER: "offer",
  DECLINED: "declined",
  IDENTITY_FAILED: "identity failed",
} as const;

export const RateEstimatePages = {
  PURPOSE: "loan purpose",
  CAR_FOUND: "found car",
  CAR_YEAR: "car manufacture year",
  CAR_SELLER: "car seller",
  CAR_AGE: "car age",
  ASSET_SECURITY: "asset security",
  AMOUNT: "loan amount",
  ABOUT_YOU: "about you",
  RELATIONSHIP_STATUS: "marital status",
  LIVING_SITUATION: "living arrangement",
  INVESTMENT_OWNED: "own investment property",
  INVESTMENT_MORTGAGED: "investment mortgaged",
  CURRENT_ADDRESS: "address",
  CURRENT_MOVED_IN: "how long at address",
  PREVIOUS_ADDRESS: "previous address",
  PREVIOUS_MOVED_IN: "how long at previous address",
  CURRENT_EMPLOYMENT_STATUS: "employment status",
  CURRENT_EMPLOYMENT_LENGTH: "how long at employment",
  PREVIOUS_EMPLOYMENT_STATUS: "previous employment status",
  PREVIOUS_EMPLOYMENT_LENGTH: "how long at previous employment",
  INCOME: "income",
  NO_MATCH: "no match",
  IDENTIFICATION: "identification",
};

export const AppFormPages = {
  ABOUT_YOU: "about you",
  ID_DOCS: "your id documents",
  LIVING: "living situation",
  EMPLOYMENT: "employment and income",
  OTHER_INCOME: "other income",
  SPENDING: "your spending",
  DEBTS: "your debts",
  STATEMENTS: "your bank statements",
  REVIEW: "review application",
  SIGNIFICANT_CHANGES: "significant changes",
  BELOW_NSR: "below NSR",
};
